import core from "@gtmhub/core/module";
import { AutomationSidebarCtrl } from "./controllers/automation-sidebar";
import { AutomationListCtrl } from "./controllers/automation-list";
import { AutomationRulesCtrl } from "./controllers/rules";
import { AutomationTriggerCtrl } from "./controllers/trigger";
import { AutomationConditionCtrl } from "./controllers/condition";
import { AutomationActionCtrl } from "./controllers/action";
import { AutomationHistoryCtrl } from "./controllers/history";
import { AutomationService } from "./services/automation";

export default angular
  .module("automation", [core])
  .controller("AutomationSidebarCtrl", AutomationSidebarCtrl)
  .controller("AutomationListCtrl", AutomationListCtrl)
  .controller("AutomationRulesCtrl", AutomationRulesCtrl)
  .controller("AutomationTriggerCtrl", AutomationTriggerCtrl)
  .controller("AutomationConditionCtrl", AutomationConditionCtrl)
  .controller("AutomationActionCtrl", AutomationActionCtrl)
  .controller("AutomationHistoryCtrl", AutomationHistoryCtrl)
  .service("AutomationService", AutomationService).name;
